
import Vue from 'vue';
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme.vue';
import AboutUs from '@/components/partials/landings/about-us/AboutUs.vue';

export default Vue.extend({
  name: 'AboutUsPage',
  components: {
    AboutUs,
    BravadoTheme,
  },
  layout: 'clear',
  // @ts-ignore
  colorMode: 'dark',
  head() {
    return this.$seo({
      title: 'About Bravado Company',
      description:
        'Whether you’re an SDR trying to get promoted to AE, or a seasoned VP of Sales needing an executive network to support you, Bravado offers resources to help sales professionals be successful',
    });
  },
});
